const EXCLUDED_ANCHORS = new Set(['#SHORT_URL#']);

export const detectUsedAnchors = (content: string, availableAnchors: Set<string>): string[] => {
  const tokens = Array.from(content.matchAll(/#([^#]+)#/g), match => `#${match[1]}#`);
  return Array.from(new Set(tokens.filter(token => availableAnchors.has(token) && !EXCLUDED_ANCHORS.has(token))));
};

export const replaceAnchors = (content: string, values: Record<string, string>, anchors: string[]) =>
  anchors.reduce((merged, anchor) => merged.split(anchor).join(values[anchor] ?? ''), content);
